import { getHealthMetricUnitDisplayValue } from '#utils/get-health-metric-unit-display-value.ts';
import {
  DATE_FORMAT,
  useFormatDateByUserProfileLocation,
} from '@leagueplatform/web-common';
import { useHealthMetricValuesV3 } from '#components/charts/core/range-graph/utils/use-health-metric-values.ts';

type Datum = ReturnType<typeof useHealthMetricValuesV3>[number];

const generateLabel = (singleDatum: Datum) => {
  if (singleDatum.value === null) {
    return '';
  }

  const metricName = singleDatum.metric.data.name;
  const value = Array.isArray(singleDatum.value)
    ? singleDatum.value.join('–')
    : singleDatum.value;
  const unitName = getHealthMetricUnitDisplayValue(
    singleDatum.value,
    singleDatum.metric.data.unit,
  );

  return `${metricName} ${value} ${unitName}`;
};

// Example:
// Range: May 31, 2023, Systolic 90-100 millimeters of mercury
// Single: May 31, 2023, Systolic 90 systolic
// Multiple data types: July 31, 2019, Systolic 60 mmHg, Diastolic 10-40 mmHg
export function useDatumLabel() {
  const formatDateWithUserProfileLocation =
    useFormatDateByUserProfileLocation();

  return (datum: Datum | Datum[]) => {
    if (Array.isArray(datum)) {
      const label = datum.filter((d) => d.value !== null).map(generateLabel);
      const date = formatDateWithUserProfileLocation(
        new Date(datum[0].timestamp),
        DATE_FORMAT,
      );

      if (label.length === 0) {
        return '';
      }

      return `${date}, ${label.join(', ')}`;
    }

    if (datum.value === null) {
      return '';
    }

    const label = generateLabel(datum);
    const date = formatDateWithUserProfileLocation(
      new Date(datum.timestamp),
      DATE_FORMAT,
    );

    return `${date}, ${label}`;
  };
}
